export default __webpack_public_path__ + "static/media/brand_id_12.228babc7.jpg";